
import { IRoute } from '../common/interfaces/route.interface';
import MenuLink from './MenuLink';

interface MenuItemProps {
  item: IRoute;
  activeRoute: IRoute;
  isNarrow?: boolean;
  onClick: (item: IRoute) => void;
}

const MenuItem = ({ item, activeRoute, isNarrow, onClick }: MenuItemProps) => {
  return (
    <MenuLink
      item={item}
      active={item.id === activeRoute.id}
      isNarrow={isNarrow}
      onClick={onClick}
    />
  );
};

export default MenuItem;
